var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"highlight"},[_vm._l((_vm.highlights),function(result,index){return [(result.match)?[_c('strong',{key:index},[_vm._v(_vm._s(result.text))])]:[_vm._v(_vm._s(result.text))]]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }